<template>
  <b-sidebar
    v-if="sidebarWidth !== ''"
    id="sidebar-right"
    bg-variant="white"
    right
    lazy
    backdrop
    no-header
    shadow
    :width="sidebarWidth"
    @shown="checkUnsavedNewGood"
    @hidden="() => { if (!addGood) resetSidebarData() }"
    ref="sidebar"
  >
    <template v-slot:default="{ hide }">
      <div v-if="isRefVisible" @click="closeRefs" class="close-ref"></div>
      <b-container fluid>
        <b-button-close @click="hide()"></b-button-close>
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form @submit.stop.prevent="handleSubmit(saveFormData)" autocomplete="off">
            <h2 v-if="addGood">Добавление товара</h2>
            <h2 v-else>Редактирование товара</h2>
            <b-row>
              <b-col xl="4" lg="4" md="4" sm="4" cols="12">
                <validation-provider
                  ref="GoodsCode"
                  :name="'Код товара по ТНВЭД'"
                  :rules="{ max: 10, evenAmountOfChars: goodsForm.GOODS_ITEM[0].GoodsCode }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-1"
                    label="Код товара по ТНВЭД"
                    label-for="input-1"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].GoodsCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-1"
                      :class="(!!goodsForm.GOODS_ITEM[0].GoodsCode) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.GOODS_ITEM[0].GoodsCode"
                      placeholder="Код товара по ТНВЭД"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="8" lg="8" md="8" sm="8" cols="12">
                <custom-input
                  ref="GoodsDescription"
                  inputId="GoodsDescription"
                  inputName="Описание товара"
                  :targetInput="targetInput"
                  type="simple"
                  :disabled="notForEdit"
                  :inputValidationRules="{ max: 32768 }"
                  :edited="true"
                  :required="false"
                  @setForm="setModel($event)"
                  @setTargetInput="setTarget($event)"
                  @closeRefs="closeRefs"
                  @setRefVisible="setVisible($event)"
                ></custom-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="GrossWeightQuantity"
                  :name="'Вес товара, брутто'"
                  :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/ }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-3"
                    label="Вес брутто (кг)"
                    label-for="input-3"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].GrossWeightQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-3"
                      :class="(!!goodsForm.GOODS_ITEM[0].GrossWeightQuantity) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.GOODS_ITEM[0].GrossWeightQuantity"
                      placeholder="Вес брутто (кг)"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="NetWeightQuantity"
                  :name="'Вес товара, нетто'"
                  :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/ }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-4"
                    label="Вес нетто (кг)"
                    label-for="input-4"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].NetWeightQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-4"
                      :class="(!!goodsForm.GOODS_ITEM[0].NetWeightQuantity) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.GOODS_ITEM[0].NetWeightQuantity"
                      placeholder="Вес нетто (кг)"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="GoodsQuantity"
                  :name="'Количество товара'"
                  :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/, required: Boolean((goodsForm.GOODS_ITEM[0].MeasureUnitQualifierCode && (goodsForm.GOODS_ITEM[0].MeasureUnitQualifierCode.length > 0)) || (goodsForm.GOODS_ITEM[0].MeasureUnitQualifierName && (goodsForm.GOODS_ITEM[0].MeasureUnitQualifierName.length > 0))) }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-5"
                    label="Количество товара"
                    label-for="input-5"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].GoodsQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-5"
                      :class="(!!goodsForm.GOODS_ITEM[0].GoodsQuantity) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.GOODS_ITEM[0].GoodsQuantity"
                      placeholder="Количество товара"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <custom-input
                  v-show="false"
                  ref="MeasureUnitQualifierCode"
                  inputId="MeasureUnitQualifierCode"
                  inputName="Код единицы измерения товара"
                  :inputValidationRules="{ max: 3 }"
                  :inputItems="nsiMeasurement"
                  :targetInput="targetInput"
                  :inputFields="[
                    { key: 'code', label: 'Код' },
                    { key: 'abbr', label: 'Аббревиатура' },
                    { key: 'name', label: 'Наименование' }
                  ]"
                  :inputRelatedFields="[
                    { MeasureUnitQualifierName: 'abbr' }
                  ]"
                  :loadOnFocus="true"
                  :getData="loadNsiMeasurement"
                  :disabled="notForEdit"
                  :delay="1"
                  query="p"
                  select="code"
                  @setForm="setModel($event)"
                  @setTargetInput="setTarget($event)"
                  @closeRefs="closeRefs"
                  @setRefVisible="setVisible($event)"
                  @setRelatedFields="setRelated($event)"
                ></custom-input>
                <custom-input
                  ref="MeasureUnitQualifierName"
                  inputId="MeasureUnitQualifierName"
                  inputName="Единица измерения товара"
                  :inputValidationRules="{ max: 13 }"
                  :inputItems="nsiMeasurement"
                  :targetInput="targetInput"
                  :inputFields="[
                    { key: 'code', label: 'Код' },
                    { key: 'abbr', label: 'Аббревиатура' }
                  ]"
                  :inputRelatedFields="[
                    { MeasureUnitQualifierCode: 'code' }
                  ]"
                  :loadOnFocus="true"
                  :getData="loadNsiMeasurement"
                  :disabled="notForEdit"
                  :delay="1"
                  query="p"
                  select="abbr"
                  @setForm="setModel($event)"
                  @setTargetInput="setTarget($event)"
                  @closeRefs="closeRefs"
                  @setRefVisible="setVisible($event)"
                  @setRelatedFields="setRelated($event)"
                ></custom-input>
              </b-col>
            </b-row>
            <h4 class="form-title">Габариты</h4>
            <b-row>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="goodsForm.GOODS_ITEM[0].Length"
                  :name="'Длина'"
                  :rules="{ required: Boolean((goodsForm.GOODS_ITEM[0].Width && (goodsForm.GOODS_ITEM[0].Width > 0)) || (goodsForm.GOODS_ITEM[0].Height && (goodsForm.GOODS_ITEM[0].Height.length > 0)) || (goodsForm.GOODS_ITEM[0].DimensionsCode && (goodsForm.GOODS_ITEM[0].DimensionsCode > 0))) }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-10"
                    label="Длина"
                    label-for="input-10"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].Length) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-10"
                      :class="{ 'form-input': true, 'filled-field': (!!goodsForm.GOODS_ITEM[0].Length) }"
                      v-model="goodsForm.GOODS_ITEM[0].Length"
                      placeholder="Длина"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="goodsForm.GOODS_ITEM[0].Width"
                  :name="'Ширина'"
                  :rules="{ required: Boolean((goodsForm.GOODS_ITEM[0].Length && (goodsForm.GOODS_ITEM[0].Length > 0)) || (goodsForm.GOODS_ITEM[0].Height && (goodsForm.GOODS_ITEM[0].Height.length > 0)) || (goodsForm.GOODS_ITEM[0].DimensionsCode && (goodsForm.GOODS_ITEM[0].DimensionsCode > 0))) }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-10"
                    label="Ширина"
                    label-for="input-10"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].Width) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-10"
                      :class="{ 'form-input': true, 'filled-field': (!!goodsForm.GOODS_ITEM[0].Width) }"
                      v-model="goodsForm.GOODS_ITEM[0].Width"
                      placeholder="Ширина"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="goodsForm.GOODS_ITEM[0].Height"
                  :name="'Высота'"
                  :rules="{ required: Boolean((goodsForm.GOODS_ITEM[0].Length && (goodsForm.GOODS_ITEM[0].Length > 0)) || (goodsForm.GOODS_ITEM[0].Width && (goodsForm.GOODS_ITEM[0].Width.length > 0)) || (goodsForm.GOODS_ITEM[0].DimensionsCode && (goodsForm.GOODS_ITEM[0].DimensionsCode > 0))) }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-11"
                    label="Высота"
                    label-for="input-11"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].Height) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-11"
                      :class="{ 'form-input': true, 'filled-field': (!!goodsForm.GOODS_ITEM[0].Height) }"
                      v-model="goodsForm.GOODS_ITEM[0].Height"
                      placeholder="Высота"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <custom-input
                  ref="DimensionsCode"
                  inputId="DimensionsCode"
                  inputName="Код единицы измерения"
                  :inputValidationRules="{ max: 3, required: Boolean((goodsForm.GOODS_ITEM[0].Width && (goodsForm.GOODS_ITEM[0].Width > 0)) || (goodsForm.GOODS_ITEM[0].Height && (goodsForm.GOODS_ITEM[0].Height.length > 0)) || (goodsForm.GOODS_ITEM[0].Length && (goodsForm.GOODS_ITEM[0].Length > 0))) }"
                  :inputItems="nsiMeasurement"
                  :targetInput="targetInput"
                  :inputFields="[
                    { key: 'code', label: 'Код' },
                    { key: 'abbr', label: 'Аббревиатура' },
                    { key: 'name', label: 'Наименование' }
                  ]"
                  :getData="loadNsiMeasurement"
                  :disabled="notForEdit"
                  :delay="1"
                  query="p"
                  select="code"
                  @setForm="setModel($event)"
                  @setTargetInput="setTarget($event)"
                  @closeRefs="closeRefs"
                  @setRefVisible="setVisible($event)"
                  @setRelatedFields="setRelated($event)"
                ></custom-input>
              </b-col>
            </b-row>
            <h4 class="form-title">Стоимость</h4>
            <b-row>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                  <custom-input
                    v-show="false"
                    ref="CurrencyCode"
                    inputId="CurrencyCode"
                    inputName="Код иностранной валюты"
                    :inputValidationRules="{ max: 3 }"
                    :inputItems="nsiCurrency"
                    :inputFields="[
                      { key: 'abbr', label: 'Код' },
                      { key: 'name', label: 'Наименование' },
                    ]"
                    :inputRelatedFields="[
                       { CurrencyCodeABR: 'abbr' }
                     ]"
                    :targetInput="targetInput"
                    :getData="loadNsiCurrency"
                    :delay="1"
                    select="code"
                    query="p"
                    @setRelatedFields="setRelated($event)"
                    @setForm="setModel($event)"
                    @setTargetInput="setTarget($event)"
                    @closeRefs="closeRefs"
                    @setRefVisible="setVisible($event)"
                  ></custom-input>
                  <custom-input
                  ref="CurrencyCodeABR"
                  inputId="CurrencyCodeABR"
                  inputName="Валюта"
                  :inputValidationRules="{ max: 3 }"
                  :inputItems="nsiCurrency"
                  :targetInput="targetInput"
                  :inputFields="[
                    { key: 'abbr', label: 'Код' },
                    { key: 'name', label: 'Наименование' }
                  ]"
                  :inputRelatedFields="[
                    { CurrencyCode: 'code' }
                  ]"
                  :loadOnFocus="true"
                  :getData="loadNsiCurrency"
                  :disabled="notForEdit"
                  :delay="1"
                  query="p"
                  select="abbr"
                  @setForm="setModel($event)"
                  @setTargetInput="setTarget($event)"
                  @closeRefs="closeRefs"
                  @setRefVisible="setVisible($event)"
                  @setRelatedFields="setRelated($event)"
                ></custom-input>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="CurrencyQuantity"
                  :name="'Стоимость'"
                  :rules="{ regex: /^\d{0,10}[.]?\d{0,2}?$/, required: true }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-10"
                    :label="'Стоимость' + (goodsForm.GOODS_ITEM[0].CurrencyCodeABR ? ' в ' + goodsForm.GOODS_ITEM[0].CurrencyCodeABR : '')"
                    label-for="input-10"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].CurrencyQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-10"
                      :class="{ 'form-input': true, 'filled-field': (!!goodsForm.GOODS_ITEM[0].CurrencyQuantity), 'required-field': !(!!goodsForm.GOODS_ITEM[0].CurrencyQuantity) }"
                      v-model="goodsForm.GOODS_ITEM[0].CurrencyQuantity"
                      :placeholder="'Стоимость' + (goodsForm.GOODS_ITEM[0].CurrencyCodeABR ? ' в ' + goodsForm.GOODS_ITEM[0].CurrencyCodeABR : '')"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="CurrencyQuantitySub"
                  :name="'Стоимость в RUB'"
                  :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/ }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-11"
                    label="Стоимость в RUB"
                    label-for="input-11"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].CurrencyQuantitySub) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-11"
                      :class="(!!goodsForm.GOODS_ITEM[0].CurrencyQuantitySub) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.GOODS_ITEM[0].CurrencyQuantitySub"
                      placeholder="Стоимость в RUB"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                    <custom-input
                      v-show="false"
                      ref="CurrencyCodeSub"
                      inputId="CurrencyCodeSub"
                      @setForm="setModel($event)"
                      @setTargetInput="setTarget($event)"
                      @closeRefs="closeRefs"
                      @setRefVisible="setVisible($event)"
                    ></custom-input>
                    <custom-input
                      v-show="false"
                      ref="CurrencyCodeSubABR"
                      inputId="CurrencyCodeSubABR"
                      @setForm="setModel($event)"
                      @setTargetInput="setTarget($event)"
                      @closeRefs="closeRefs"
                      @setRefVisible="setVisible($event)"
                    ></custom-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="CustomsCost"
                  :name="'Таможенная стоимость в RUB'"
                  :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/ }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-12"
                    label="Таможенная стоимость в RUB"
                    label-for="input-12"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].CustomsCost) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-12"
                      :class="(!!goodsForm.GOODS_ITEM[0].CustomsCost) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.GOODS_ITEM[0].CustomsCost"
                      placeholder="Таможенная стоимость в RUB"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                    <custom-input
                      v-show="false"
                      ref="CustomsCurrencyCode"
                      inputId="CustomsCurrencyCode"
                      @setForm="setModel($event)"
                      @setTargetInput="setTarget($event)"
                      @closeRefs="closeRefs"
                      @setRefVisible="setVisible($event)"
                    ></custom-input>
                    <custom-input
                      v-show="false"
                      ref="CustomsCurrencyCodeABR"
                      inputId="CustomsCurrencyCodeABR"
                      @setForm="setModel($event)"
                      @setTargetInput="setTarget($event)"
                      @closeRefs="closeRefs"
                      @setRefVisible="setVisible($event)"
                    ></custom-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <h4 class="form-title">Дополнительно</h4>
            <b-row>
              <b-col xl="12" lg="12" md="12" sm="12" cols="12">
                <custom-input
                  ref="URLGood"
                  inputId="URLGood"
                  inputName="Ссылка на товар в интернет магазине"
                  type="simple"
                  :disabled="notForEdit"
                  :edited="true"
                  :required="false"
                  @setForm="setModel($event)"
                  @setTargetInput="setTarget($event)"
                  @closeRefs="closeRefs"
                  @setRefVisible="setVisible($event)"
                ></custom-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col xl="6" lg="6" md="6" sm="6" cols="12">
                <validation-provider
                  ref="Procedure"
                  :name="'Товарный знак'"
                  :rules="{ max: 250 }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-14"
                    label="Товарный знак"
                    label-for="input-14"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].TradeMark) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-14"
                      :class="(!!goodsForm.GOODS_ITEM[0].TradeMark) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.GOODS_ITEM[0].TradeMark"
                      placeholder="Товарный знак"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="6" lg="6" md="6" sm="6" cols="12">
                <validation-provider
                  ref="VolumeQuantity"
                  :name="'Место происхождения'"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-15"
                    label="Место происхождения"
                    label-for="input-15"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].ProductionPlaceName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-15"
                      :class="(!!goodsForm.GOODS_ITEM[0].ProductionPlaceName) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.GOODS_ITEM[0].ProductionPlaceName"
                      placeholder="Место происхождения"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col xl="12" lg="12" md="12" sm="12" cols="12">
                <validation-provider
                  ref="Note"
                  :name="'Примечание'"
                  :rules="{ max: 40 }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-16"
                    label="Примечание"
                    label-for="input-16"
                    :label-class="(!!goodsForm.GOODS_ITEM[0].Note) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-16"
                      :class="(!!goodsForm.GOODS_ITEM[0].Note) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.GOODS_ITEM[0].Note"
                      placeholder="Примечание"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row class="mb-3 mt-3">
              <b-col xl="6" lg="12" md="12" sm="12" cols="12">
                <div class="d-md-flex d-lg-flex align-items-start">
                  <span v-b-tooltip.hover :title="notForEdit ? 'В текущем статусе изменение пакета невозможно' : ''">
                    <b-button
                      variant="success"
                      :disabled="notForEdit"
                      type="submit"
                      class="btn-action-success mr-3 mb-2"
                      squared size="sm"
                    >
                    <span v-if="addGood">Добавить товар</span>
                    <span v-else>Изменить товар</span>
                  </b-button>
                  </span>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-container>
    </template>
  </b-sidebar>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { extend } from 'vee-validate'
  import idbapi from '../../../idbapi/idb.js'
  import CustomInput from '../../CustomInput'
  export default {
    name: "AddHouseShipmentGoodsPage",
    components: {
      CustomInput
    },
    props: ['addGood', 'notForEdit'],
    data () {
      return {
        targetInput: null,
        isRefVisible: false,
        promise: window.Promise,
        goodsForm: {
          GOODS_ITEM: [
            {
              GoodsNumeric: null, // Номер товара в ДТ
              GoodsCode: null, // Код ТН ВЭД
              GoodsDescription: null, // Наименование товара
              GrossWeightQuantity: null, // Вес товара, брутто (кг)
              NetWeightQuantity: null, // Вес товара, нетто (кг) +
              GoodsQuantity: null, // Количество товара
              MeasureUnitQualifierCode: null, // Код единицы измерения товара
              MeasureUnitQualifierName: null, // Название единицы измерения при возможности ее указания
              URLGood: null, // Ссылка на товар в интернет магазине
              TradeMark: null, // Товарный знак
              Note: null, // Примечание
              CurrencyCode: null, // Код иностранной валюты
              CurrencyCodeABR: null, // Код иностранной валюты
              CurrencyCodeSub: '643', // Код иностранной валюты
              CurrencyCodeSubABR: 'RUB', // Код иностранной валюты
              CurrencyQuantity: null, // Стоимость товара
              CurrencyQuantitySub: null, // Стоимость товара (допол.)
              CustomsCost: null, // Таможенная стоимость товара
              CustomsCurrencyCode: '643', // Код иностранной валюты
              CustomsCurrencyCodeABR: 'RUB', // Код иностранной валюты
              Length: null,
              Width: null,
              Height: null,
              DimensionsCode: null,
              PRESENTEDDOC: {
                PRESENTEDDOC_ITEM: [
                  {
                    ModeCode: null, // Вид документа
                    DocumentName: null, // Наименование документа
                    DocumentNumber: null, // Номер документа
                    DocumentDate: null // Дата документа
                  }
                ]
              },
            }
          ]
        },
        sidebarWidth: '',
        collapseDocumentsVisible: false,
      }
    },
    watch: {
      'goodsForm.GOODS_ITEM': {
        handler () {
        },
        deep: true
      },
    },
    computed: {
      ...mapState(
        {
          nsiMeasurement: state => state.commissionShipment.nsiMeasurement,
          nsiCurrency: state => state.houseShipment.nsiCurrency,
          mobile: state => state.mobile,
          tablet: state => state.tablet,
          desktop: state => state.desktop,
          largeDesktop: state => state.largeDesktop
        }
      )
    },
    mounted () {
      this.calcSidebarWidth()
      extend('evenAmountOfChars', {
        validate (value) {
          const even = ((value.length % 2) === 0)
          return even && (value.length > 2)
        },
        params: ['length'],
        message: 'Код товара по ТН ВЭД может содержать 4, 6, 8, 10 символов'
      })
    },
    methods: {
      setModel (event) {
        this.goodsForm.GOODS_ITEM[0][event.fieldName] = event.item
        this.updateIdbData()
      },
      closeRefs () {
        const keys = Object.keys(this.goodsForm.GOODS_ITEM[0])
        for (let i = 0; i < keys.length; i++) {
          if (this.$refs[keys[i]] && this.$refs[keys[i]].items) {
            this.$refs[keys[i]].items = []
          }
        }
        this.isRefVisible = false
      },
      setTarget (event) {
        this.targetInput = event
      },
      setRelated (event) {
        event.relatedFields.map((field) => {
          const key = Object.keys(field)[0]
          this.goodsForm.GOODS_ITEM[0][key] = event.item[field[key]]
          this.$refs[key].model = event.item[field[key]]
          if (/^\d{4}-\d{2}-\d{2}$/.test(event.item[field[key]])) {
            let date = event.item[field[key]].split('-')
            date = date[2] + '.' + date[1] + '.' + date[0]
            this.$refs[key].model = date
          }
        })
        this.updateIdbData()
      },
      setVisible (event) {
        this.isRefVisible = event
      },
      checkUnsavedNewGood () {
        if (this.addGood) {
          idbapi.getPackageData().then(
            (documents) => {
              if (documents && (documents.length > 0)) {
                if (Object.keys(documents[0]).indexOf('unsavedNewGood' !== -1)) {
                  this.goodsForm.GOODS_ITEM[0] = Object.assign(this.goodsForm.GOODS_ITEM[0], documents[0].unsavedNewGood)
                  this.$nextTick(() => {
                    this.setRefsModels()
                  })
                }
              }
            }
          )
        }
      },
      setRefsModels () {
        const keys = Object.keys(this.goodsForm.GOODS_ITEM[0])
        for (let i = 0; i < keys.length; i++) {
          if ((keys[i] === 'GoodsDescription') ||
            (keys[i] === 'MeasureUnitQualifierCode') ||
            (keys[i] === 'MeasureUnitQualifierName') ||
            (keys[i] === 'CurrencyCode') ||
            (keys[i] === 'CurrencyCodeABR') ||
            (keys[i] === 'CurrencyCodeSub') ||
            (keys[i] === 'CustomsCurrencyCode') ||
            (keys[i] === 'CustomsCurrencyCodeABR') ||
            (keys[i] === 'CurrencyCodeSubABR') ||
            (keys[i] === 'DimensionsCode') ||
            (keys[i] === 'URLGood')) {
            this.$refs[keys[i]].model = this.goodsForm.GOODS_ITEM[0][keys[i]]
          }
        }
      },
      async updateIdbData () {
        await idbapi.getPackageData().then(
          (documents) => {
            if (documents && (documents.length > 0)) {
              if (this.addGood) {
                idbapi.addUnsavedNewGood(this.goodsForm.GOODS_ITEM[0])
              }
            } else {
              if (this.addGood) {
                this.$emit('saveEmptyPackageInIdb')
                setTimeout(() => {
                  idbapi.addUnsavedNewGood(this.goodsForm.GOODS_ITEM[0])
                }, 200)
              }
            }
          }
        )
      },
      mergeEditedGoodsItem (item) {
        Object.assign(this.goodsForm.GOODS_ITEM[0], item)
        this.$nextTick(() => {
          this.setRefsModels()
        })
        this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
      },
      calcSidebarWidth () {
        if (this.largeDesktop) {
          this.sidebarWidth = '1024px'
        }else if (this.desktop){
          this.sidebarWidth = '100%'
        } else if (this.mobile || this.tablet) {
          this.sidebarWidth = '100%'
        }
      },
      getValidationState ({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null
      },
      resetSidebarData () {
        const props = Object.getOwnPropertyNames(this.goodsForm.GOODS_ITEM[0])
        for (let i = 0; i < props.length; i++) {
            this.goodsForm.GOODS_ITEM[0][props[i]] = null
        }
        this.$refs.observer.reset()
      },
      async saveFormData () {
        if (this.addGood) {
          await idbapi.deleteUnsavedNewGood()
          await this.$emit('addGoods', JSON.parse(JSON.stringify(this.goodsForm)))
        } else {
          await this.$emit('editGoods', JSON.parse(JSON.stringify(this.goodsForm)))
        }
        this.$refs.sidebar.hide()
      },
      ...mapActions({
        loadNsiMeasurement: 'commissionShipment/loadNsiMeasurement',
        loadNsiDocuments: 'commissionShipment/loadNsiDocuments',
        loadNsiCurrency: 'houseShipment/loadNsiCurrency'
      })
    }
  }
</script>

<style lang="scss" scoped>
  h2 {
    margin-bottom: 20px;
    margin-top: 10px;
    color: #37474F;
    font-size: 25px;
    font-weight: 500;
    line-height: 28px;
  }
  #ProcedureOptions {
    border-radius: 0 !important;
  }
  .form-input-wrapper {
    position: relative !important;
    & .nsi-tooltips-wrapper {
      position: absolute;
      top: 36px;
      z-index: 10000;
      background-color: #ffffff;
      box-shadow: 0 4px 12px 0 rgb(0 0 0 / 30%);
      max-height: 200px;
      overflow-y: auto;
      overflow-x: hidden;
      & .fa-xmark {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        &:hover {
          color: #000000;
        }
      }
    }
  }
  .GoodsDescription {
    border-radius: 0 !important;
  }
  .excel-link {
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
    margin-bottom: 5px;
  }
  .custom-invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e7161a;
  }
  .close-ref {
    height: 100%;
    width: 100%;
    z-index: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    background-color: transparent;
    /* background-color: #989fa4; */
  }
</style>
